import { Component, OnInit, ViewChild } from '@angular/core';
import each from 'lodash/each';
import get from 'lodash/get';

import { I18nService } from '../services';

@Component({
	selector: 'app-localize-api-strings',
	templateUrl: './i18n-api-strings-here.html'
})
export class I18nApiStringsComponent implements OnInit {
	@ViewChild('i18nApiStrings', { static: true }) i18nApiStrings;

	private idPrefix = 'api.error-code.';

	constructor(private i18nService: I18nService) {}

	/**
	 * translatable i18n strings are mainly in the 'app.component.html' template
	 * moving the translated i18n string from the DOM to the i18nService class
	 * then clean the html elements as they are not needed any further
	 */

	ngOnInit() {
		const elm = get(this.i18nApiStrings, 'nativeElement');
		const children: HTMLElement[] = get(elm, 'children', []);

		each(children, (child: HTMLElement) => {
			const errorCode = child.getAttribute('errorCode');
			const id = this.idPrefix + errorCode;
			const value = child.innerHTML;
			this.i18nService.set(value, id);
		});

		Array.from(children)?.forEach((child) => {
			elm.removeChild(child);
		});
	}
}
